// Version : 1.0.0
// Author : AGALYA

import OfficialDetailsActionType from './official-details.types';

/** ***************** Official Details Add Start ************************/
export const officialDetailsAddStart = (officialDetailsCredentials: any) => ({
	type: OfficialDetailsActionType.OFFICIAL_DETAILS_ADD_START,
	payload: officialDetailsCredentials,
});

export const officialDetailsAddSuccess = (officialDetailsSuccess: any) => ({
	type: OfficialDetailsActionType.OFFICIAL_DETAILS_ADD_SUCCESS,
	payload: officialDetailsSuccess,
});

export const officialDetailsAddFailure = (officialDetailsFailure: unknown) => ({
	type: OfficialDetailsActionType.OFFICIAL_DETAILS_ADD_FAILURE,
	payload: officialDetailsFailure,
});

export const officialDetailsAddResponseResetStart = () => ({
	type: OfficialDetailsActionType.OFFICIAL_DETAILS_ADD_RESPONSE_REST_START,
});

export const officialDetailsAddUserResponseChanged = () => ({
	type: OfficialDetailsActionType.OFFICIAL_DETAILS_ADD_RESPONSE_CHANGED,
});
/** ***************** Official Details Add End ************************/

/** ***************** Economic Activity List Start ************************/
export const economicActivityListStart = (economicActivityCredentials: any) => ({
	type: OfficialDetailsActionType.ECONOMIC_ACTIVITY_LIST_START,
	payload: economicActivityCredentials,
});

export const economicActivityListSuccess = (economicActivitySuccess: any) => ({
	type: OfficialDetailsActionType.ECONOMIC_ACTIVITY_LIST_SUCCESS,
	payload: economicActivitySuccess,
});

export const economicActivityListFailure = (economicActivityFailure: unknown) => ({
	type: OfficialDetailsActionType.ECONOMIC_ACTIVITY_LIST_FAILURE,
	payload: economicActivityFailure,
});

export const economicActivityListResponseResetStart = () => ({
	type: OfficialDetailsActionType.ECONOMIC_ACTIVITY_LIST_RESPONSE_REST_START,
});

export const economicActivityListUserResponseChanged = () => ({
	type: OfficialDetailsActionType.ECONOMIC_ACTIVITY_LIST_RESPONSE_CHANGED,
});
/** ***************** Economic Activity List End ************************/
